import React, { useState } from "react";
import "../components/Login.css";

import blomstereng from "../assets/images/blomstereng.png";

const flowerStyle = {
  maxWidth: "100vw",
  maxHeight: "20vh",
  // width: "auto",
  // height: "auto",
  marginLeft: "-40px", // 🔑 overlap
};

export default function Login() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const correctCode = "18072026";
  // const correctCode = "01062023";

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    if (code === correctCode) {
      localStorage.setItem("isLoggedIn", "true");
      window.location.href = "/";
    } else {
      setError("Feil kode. Prøv igjen.");
    }
  }

  return (
    <section className="login-section">
      <h1 className="login-title">Skriv inn koden fra invitasjonen</h1>

      <form className="login-form" onSubmit={handleSubmit}>
        <input
          className="login-input"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Skriv koden her"
          required
        />
        {error && <p className="login-error">{error}</p>}
        <button type="submit" className="login-button">
          Fortsett
        </button>
      </form>

            <div
        style={{
          position: "absolute",
          bottom: "-1.1rem",
          left: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none", // optional, avoids blocking clicks
        }}
      >
        {Array.from({ length: Math.ceil(window.innerWidth / 250) }).map((_, i) => (
          <img
            key={i}
            src={blomstereng}
            alt=""
            style={flowerStyle}
          />
        ))}
      </div>
    </section>
  );
}
